import { HermesTheme } from '@seller-hermes/hooks/useSellerTheme/use-seller-theme';
import { ITheme as IAbbiamoUiTheme } from './theme';

export const theme = {
  borderRadius: '5px',
  type: 'light',
  maxWidthNumber: 1600,
  maxWidth: '1600px',
  defaultShadow:
    '0px 4px 4px rgba(172, 172, 172, 0.25), 0px -2px 4px rgba(172, 172, 172, 0.25)',
  badgeBorder: {
    DISPATCHED: '#046061',
    CREATED: '#AB6800',
    START_DELIVERY: '#1A76D2',
    CANCELED: '#626262',
    SUCCESSFUL: '#1AA251',
    FAILED: '#C70011',
    PENDING: '#78909c',
    HANDLING: '#1A76D2',
    COLLECTED: '#1A76D2',
    MANUAL_HANDLE: '#626262',
  },
  badgeBg: {
    DISPATCHED: '#046061',
    CREATED: '#AB6800',
    START_DELIVERY: '#1A76D2',
    CANCELED: '#626262',
    SUCCESSFUL: '#1AA251',
    FAILED: '#C70011',
    PENDING: '#78909c',
    HANDLING: '#1A76D2',
    COLLECTED: '#1A76D2',
    MANUAL_HANDLE: '#626262',
  },
  badgeColor: {
    DISPATCHED: '#046061',
    CREATED: '#AB6800',
    START_DELIVERY: '#1A76D2',
    CANCELED: '#626262',
    SUCCESSFUL: '#1AA251',
    FAILED: '#C70011',
    PENDING: '#78909c',
    HANDLING: '#1A76D2',
    COLLECTED: '#1A76D2',
    MANUAL_HANDLE: '#626262',
  },
  statusColor: {
    START_DELIVERY: '#1976d2',
    CREATED: '#C5861F',
    ALL_WAYPOINTS_FINISHED: '#1A76D2',
    CANCELED: '#626262',
    FINISHED: '#00e676',
  },
  statusBorderColor: {
    START_DELIVERY: '#1976d2',
    CREATED: '#C5861F',
    ALL_WAYPOINTS_FINISHED: '#1A76D2',
    CANCELED: '#626262',
    FINISHED: '#00e676',
  },
  statusBg: {
    START_DELIVERY: '#1976d2',
    CREATED: '#C5861F',
    ALL_WAYPOINTS_FINISHED: '#1A76D2',
    CANCELED: '#626262',
    FINISHED: '#00e676',
  },
  colors: {
    blue: {
      500: '#34d8eb',
    },
    main: {
      500: '#6ED796',
    },
    green: {
      500: '#6ED796',
    },
    red: {
      500: '#f44336',
    },
    black: {
      600: '#565c5e',
      700: '#3C4042',
      800: '#2D3133',
      900: '#202124',
      950: '#101010',
      1000: '#000',
    },
    white: {
      500: '#F0F0F0',
      700: '#9A9A9A',
      900: '#b7b7b7',
      950: '#DDDDDD',
      1000: '#fff',
    },
    gray: {
      100: '#F1F1F1',
      200: '#D1D1D1',
      300: '#efefef',
      500: '#DEDEDE',
      800: '#3e3e3e',
    },
  },
  roterizador: {
    light: {
      bg: '#fff',
      gray: {
        '100': '#F1F1F1',
        '200': '#D1D1D1',
        '300': '#858585',
        '400': '#5A5A5A',
        '500': '#3C3B3B',
      },
    },
  },
  v2: {
    warn: '#F79009',
  },
  calloutBg: {
    DEFAULT: '#fff7ed',
    INFO: '#dbeafe',
    ERROR: '#fee2e2',
    WARNING: '#fefce8',
  },
  calloutColor: {
    DEFAULT: '#9a3412',
    INFO: '#1e3a8a',
    ERROR: '#7f1d1d',
    WARNING: '#713f12',
  },
  calloutBorder: {
    DEFAULT: '#ffedd5',
    INFO: '#bfdbfe',
    ERROR: '#fecaca',
    WARNING: '#fef9c3',
  },
} as const;

export type ITheme = typeof theme & {
  sellerTheme: HermesTheme;
} & IAbbiamoUiTheme;
